const CustomFieldInitialValuesMap = {
  COMMON: {
    field_name: "",
    description: "",
  },
  ADDRESS: {
    addressLineOne: "",
    addressLineTwo: "",
    city: "",
    state: "",
    country: "",
    zip: "",
  },
  PERSON_NAME: {
    firstName: "",
    lastName: "",
  },
  CHECKBOX: {
    options: [""],
    default: [false],
  },
  RADIO: {
    options: ["", ""],
    default: [false, false],
  },
  SINGLE_SELECT: {
    options: ["", ""],
    default: [false, false],
  },
  EMAIL: {
    default: "",
  },
  NUMBER: {
    default: "",
  },
  PERCENT: {
    default: "",
  },
  PHONE: {
    default: "",
  },
  SINGLE_LINE_TEXT: {
    default: "",
  },
  URL: {
    default: "",
  },
  MULTI_LINE_TEXT: {
    default: "",
  },
  DATE: {
    format: "",
  },
  COUNTRY: {
    options: [],
    default: "",
  },
  RATE: {
    options: [],
    rateValue: "",
    rateUom: "",
  },
  PERIOD: {
    options: [],
    periodValue: "",
    periodUom: "",
  },
  AMOUNT: {
    currency: "",
    default: "",
  },
  US_STATES: {
    options: [],
    default: "",
  },
};

const CustomFieldComponentRules = {
  COMMON: {
    field_name: {
      required: ({ value }) => value.trim("").length > 0,
    },
    description: {
      required: ({ value }) => value.trim("").length > 0,
      // minLength: ({ value }) => value.trim("").length > 5,
    },
  },
  ADDRESS: {
    addressLineOne: {
      required: ({ value }) => value.trim("").length > 0,
    },
    // addressLineTwo: {
    //   required: ({ value }) => value.trim("").length > 0,
    // },
    city: {
      required: ({ value }) => value.trim("").length > 0,
    },
    state: {
      required: ({ value }) => value.trim("").length > 0,
    },
    // country: {
    //   required: ({ value }) => value.trim("").length > 0,
    // },
    zip: {
      required: ({ value }) => value.trim("").length > 0,
    },
  },
  PERSON_NAME: {
    firstName: {
      required: ({ value }) => value.trim("").length > 0,
    },
    lastName: {
      required: ({ value }) => value.trim("").length > 0,
    },
  },
  SINGLE_SELECT: {
    options: {
      required: ({ value }) => value.trim("").length > 0,
    },
  },
  CHECKBOX: {
    options: {
      required: ({ value }) => value.trim("").length > 0,
    },
  },
  RADIO: {
    options: {
      required: ({ value }) => value.trim("").length > 0,
    },
  },
  EMAIL: {
    default: {
      required: ({ value }) => value.trim("").length > 0,
      validateEmail: ({ value }) => {
        // eslint-disable-next-line no-useless-escape
        const re = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
        // return re.test(String(value).toLowerCase());
        const emailstatus = re.test(String(value).toLowerCase());
        return emailstatus;
      },
    },
  },
  NUMBER: {
    default: {
      required: ({ value }) => value.trim("").length > 0,
    },
  },
  DATE: {
    format: {
      required: ({ value }) => value.trim("").length > 0,
    },
  },
  PERCENT: {
    default: {
      required: ({ value }) => value.trim("").length > 0,
      minMax: ({ value }) => value > 0 && value <= 100,
    },
  },
  AMOUNT: {
    currency: {
      required: ({ value }) => value.trim("").length > 0,
    },
    default: {
      required: ({ value }) => value.trim("").length > 0,
    },
  },
  COUNTRY: {
    default: {
      required: ({ value }) => value.trim("").length > 0,
    },
  },
  US_STATES: {
    default: {
      required: ({ value }) => value.trim("").length > 0,
    },
  },
  PHONE: {
    default: {
      required: ({ value }) => value.trim("").length > 0,
      validatePhone: ({ value }) => {
        // eslint-disable-next-line no-useless-escape
        const re = /^[0-9\b]+$/;
        const number = re.test(value);
        return number;
      },
    },
  },
  RATE: {
    rateValue: {
      required: ({ value }) => value.trim("").length > 0,
    },
  },
  PERIOD: {
    periodValue: {
      required: ({ value }) => value.trim("").length > 0,
    },
  },
  SINGLE_LINE_TEXT: {
    default: {
      required: ({ value }) => value.trim("").length > 0,
    },
  },
  MULTI_LINE_TEXT: {
    default: {
      required: ({ value }) => value.trim("").length > 0,
    },
  },
  URL: {
    default: {
      required: ({ value }) => value.trim("").length > 0,
      validateUrl: ({ value }) => {
        // eslint-disable-next-line no-useless-escape
        const re = /^(http[s]?:\/\/){0,1}(www\.){0,1}[a-zA-Z0-9\.\-]+\.[a-zA-Z]{2,5}[\.]{0,1}/;
        const urlstatus = re.test(value);
        return urlstatus;
      },
    },
  },
};

const CustomFieldComponentMessages = {
  COMMON: {
    field_name: {
      required:
        "Enter value for all fields. Ignore or leave it blank if it's not applicable to you.",
    },
    description: {
      required:
        "Enter description. Ignore or leave it blank if it's not applicable to you.",
      minLength: "Field description should have a minimum 5 characters",
    },
  },
  ADDRESS: {
    addressLineOne: {
      required:
        "Enter value for all fields. Ignore or leave it blank if it's not applicable to you",
    },
    city: {
      required:
        "Enter name of city. Ignore or leave it blank if it's not applicable to you",
    },
    state: {
      required:
        "Enter name of state. Ignore or leave it blank if it's not applicable to you",
    },
    zip: {
      required:
        "Enter ZIP code. Ignore or leave it blank if it's not applicable to you",
    },
  },
  PERSON_NAME: {
    firstName: {
      required:
        "Enter your first name. Ignore or leave it blank if it's not applicable to you",
    },
    lastName: {
      required:
        "Enter your last name. Ignore or leave it blank if it's not applicable to you",
    },
  },
  AMOUNT: {
    currency: {
      required:
        "Enter amount in numbers. Ignore or leave it blank if it's not applicable to you",
    },
    default: {
      required:
        "Enter amount in numbers. Ignore or leave it blank if it's not applicable to you",
    },
  },
  SINGLE_SELECT: {
    options: [""],
    default: [false],
  },
  RADIO: {
    options: [""],
    default: [false],
  },
  CHECKBOX: {
    options: {
      required: "Please enter a default value",
    },
  },
  EMAIL: {
    default: {
      required:
        "Enter email address. Ignore or leave it blank if it's not applicable to you",
      validateEmail: "Please enter a valid email address.",
    },
  },
  NUMBER: {
    default: {
      required:
        "Enter value in numbers. Ignore or leave it blank if it's not applicable to you",
    },
  },
  PERCENT: {
    default: {
      required:
        "Enter percentage number. Ignore or leave it blank if it's not applicable to you",
      minMax: "Value can be between 0 and 100 only",
    },
  },
  PHONE: {
    default: {
      required:
        "Enter your phone number. Ignore or leave it blank if it's not applicable to you",
      validatePhone: "Please enter a valid phone number",
    },
  },
  SINGLE_LINE_TEXT: {
    default: {
      required:
        "Please fill this field. Ignore or leave it blank if it's not applicable to you",
    },
  },
  MULTI_LINE_TEXT: {
    default: {
      required:
        "Please fill this field. Ignore or leave it blank if it's not applicable to you",
    },
  },
  RATE: {
    rateValue: {
      required:
        "Enter the rate in numbers. Ignore or leave it blank if it's not applicable to you",
    },
  },
  PERIOD: {
    periodValue: {
      required:
        "Please fill values for both fields. Ignore or leave it blank if it's not applicable to you",
    },
  },
  DATE: {
    format: {
      required: "Select the date format in which you want the date to appear",
    },
  },
  URL: {
    default: {
      required:
        "Enter a URL. Ignore or leave it blank if it's not applicable to you",
      validateUrl: "Please enter valid URL",
    },
  },
};

export {
  CustomFieldInitialValuesMap,
  CustomFieldComponentMessages,
  CustomFieldComponentRules,
};



// WEBPACK FOOTER //
// ./src/components/DocumentV2/DynamicField/DynamicFieldComponents/CustomFieldRulesMap.js